import React from 'react';
import { Avatar, Typography } from '@mui/material';
import { User } from '../../app/feathers/users/User';

function getDisplayName(user: Pick<User, 'name' | 'firstName' | 'lastName'>): string {
  if (user.name) return user.name;
  if (user.firstName && user.lastName) return `${user.firstName} ${user.lastName}`;
  if (user.firstName) return user.firstName;
  if (user.lastName) return user.lastName;
  return '--';
}

function getInitials(user: Pick<User, '_id' | 'email' | 'name' | 'firstName' | 'lastName'>): string {
  const name = getDisplayName(user);
  if (name === '--') {
    return user.email?.[0]?.toUpperCase() ?? '?';
  }
  return name
    .split(' ')
    .map((part) => part[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

function getColorFromId(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = id.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash % 360);
  return `hsl(${hue}, 85%, 40%)`;
}

export interface UserAvatarProps {
  user: Pick<User, '_id' | 'email' | 'name' | 'firstName' | 'lastName' | 'photo'>;
  size?: number;
  style?: React.CSSProperties;
  className?: string;
}

export function UserAvatar({ user, size = 32, style, className }: UserAvatarProps) {
  return (
    <Avatar
      src={user.photo}
      sx={{
        bgcolor: user.photo ? 'transparent' : getColorFromId(user._id),
        width: size,
        height: size,
        ...style,
      }}
      className={className}
    >
      {!user.photo && (
        <Typography
          sx={{
            fontSize: size * 0.4,
            fontWeight: 700,
            color: 'white',
          }}
        >
          {getInitials(user)}
        </Typography>
      )}
    </Avatar>
  );
}
